/**
 * @module Utils.Request.Helpers
 *
 */

const backupHeaders = (obj: {[key: string]: any}) => obj;

export const Response = (window as any).Response;
export const Headers = (window as any).Headers || backupHeaders;
